import { graphql } from '#@/__gql__';

export const queryCurrentUser = graphql(/* GraphQL */ `
  query CurrentUser {
    me {
      id
      email
      firstName
      lastName
      jobTitle
      externalCompany
      phone
      fax
      intercomHash
      customSignature
      featureFlags
      isAwaitingApproval
      company {
        id
        name
        type
        tags
        bidsSubmittedOnMarketplace
        config {
          id
          additionalLanguages
          premiumEnabled
        }
        permanentFeatureFlags
        primaryColor
        contrastColor
        logoKey
        mfaRequired
        hasOverdueInvoice
        organization {
          id
          ssoRequired
        }
        packageType
        isTestCompany
        isAgentProfileComplete
        isEnterpriseOpportunity
        bidRequestsCount
        bidRequestsWithSubmittedBidsCount
        submittedCertificatesCount
        hasNetworkSubcontractorsAssociated
        hasBillingAccount
        contractEndDate
        agentPricingTier
      }
      type
      isLocked
      language
      departmentType
      customDepartmentName
      isActiveCompanyOnboarding
      lastActivityAt
      notificationConfig {
        id
        appAgentSignedContract
        appBiddersAwaitingResponse
        appBiddingPeriodEnded
        appBiddingPeriodEnding
        appBidPackageStatusChanged
        appBidRequestDeclined
        appCertificateExpired
        appCertificateExpiring
        appCertificateNotProvidedInTime
        appCertificateUploadedBySubcontractor
        appContractMultiSigningCompleted
        appNewBid
        appTaskAssigned
        appTaskDone
        emailAgentSignedContract
        emailBiddersAwaitingResponse
        emailBiddingPeriodEnded
        emailBiddingPeriodEnding
        emailBidPackageStatusChanged
        emailBidRequestDeclined
        emailCertificateExpired
        emailCertificateExpiring
        emailCertificateNotProvidedInTime
        emailCertificateUploadedBySubcontractor
        emailContractMultiSigningCompleted
        emailNewBid
        emailNewMessageFromSubcontractor
        emailSummaryOfRecentMarketplaceSearch
        emailTaskAssigned
        emailTaskDone
        emailTaskInProgress
        emailTaskReminder
        emailUserAddedToBidPackageTeam
      }
      ssoEnabled
      mfaMethod
      mfaPhoneCensored
      celloToken
      workspaces {
        id
        company {
          id
          name
        }
        isCurrent
        ssoEnabled
        mfaEnabled
        mfaRequired
      }
      isNavatticEnabled
    }
  }
`);

export const queryCurrentAdmin = graphql(/* GraphQL */ `
  query CurrentAdmin {
    adminMe {
      id
    }
  }
`);

export const queryCheckWorkspace = graphql(/* GraphQL */ `
  query CheckWorkspace($workspaceId: String!) {
    checkWorkspace(workspaceId: $workspaceId) {
      loginToken
    }
  }
`);

export const querySSORedirectUrl = graphql(/* GraphQL */ `
  query SSORedirectUrl(
    $email: String!
    $expectedUserStatus: USER_STATUS!
    $redirectPath: String
    $workspaceId: String
  ) {
    ssoRedirectUrl(
      email: $email
      expectedUserStatus: $expectedUserStatus
      redirectPath: $redirectPath
      workspaceId: $workspaceId
    )
  }
`);
